// Serviço para integração com Google Sheets via Google Apps Script
// Usa Google Apps Script para salvar dados na planilha

/**
 * Configuração do Google Apps Script
 * Para usar este serviço, você precisa:
 * 1. Criar uma planilha no Google Sheets
 * 2. Criar um Google Apps Script com a função doPost
 * 3. Implantar o script como aplicativo web
 * 4. Configurar a URL do script nas variáveis de ambiente
 */

const GOOGLE_SCRIPT_CONFIG = {
  scriptUrl: process.env.REACT_APP_GOOGLE_SCRIPT_URL,
};

// Verificar se o Google Apps Script está configurado
const checkGoogleScriptConfig = () => {
  if (!GOOGLE_SCRIPT_CONFIG.scriptUrl) {
    console.warn('⚠️ URL do Google Apps Script não configurada. Configure REACT_APP_GOOGLE_SCRIPT_URL no arquivo .env');
    return false;
  }
  
  return true;
};

/**
 * Formata os dados do formulário para envio ao Google Apps Script
 */
const formatDataForScript = (formData) => {
  return {
    nome: formData.nome || '',
    telefone: formData.telefone || '',
    email: formData.email || '',
    cidade: formData.cidade || '',
    estado: formData.estado || '',
    bairro: formData.bairro || '',
    profissoes: formData.profissoes || [],
    habilidades: formData.habilidades || '',
    pretensao: formData.pretensao || '',
    experiencia: formData.experiencia || ''
  };
};

/**
 * Salva os dados na planilha via Google Apps Script usando URL simples
 */
export const saveToGoogleSheets = async (formData) => {
  try {
    console.log('Tentando salvar no Google Sheets via Apps Script...', formData);
    
    // Verifica se está configurado
    if (!checkGoogleScriptConfig()) {
      console.log('Google Apps Script não configurado, pulando salvamento...');
      return {
        success: false,
        skipped: true,
        message: 'Google Apps Script não configurado - dados não foram enviados para a planilha'
      };
    }

    // Criar URL com parâmetros
    const params = new URLSearchParams({
      nome: formData.nome || '',
      telefone: formData.telefone || '',
      email: formData.email || '',
      cidade: formData.cidade || '',
      estado: formData.estado || '',
      bairro: formData.bairro || '',
      profissoes: Array.isArray(formData.profissoes) 
        ? formData.profissoes.join(', ') 
        : formData.profissoes || '',
      habilidades: formData.habilidades || '',
      pretensao: formData.pretensao || '',
      experiencia: formData.experiencia || ''
    });
    
    const url = `${GOOGLE_SCRIPT_CONFIG.scriptUrl}?${params.toString()}`;
    
    // Usar fetch com no-cors para contornar CORS
    const response = await fetch(url, {
      method: 'GET',
      mode: 'no-cors'
    });

    console.log('Dados enviados para Google Sheets via URL');
    
    return {
      success: true,
      message: 'Dados enviados para a planilha do Google Sheets!',
      data: { url: url }
    };

  } catch (error) {
    console.error('Erro ao salvar no Google Sheets:', error);
    return {
      success: false,
      message: `Erro ao salvar na planilha: ${error.message}`,
      error: error.message
    };
  }
};

/**
 * Testa a conexão com o Google Apps Script
 */
export const testGoogleSheetsConnection = async () => {
  try {
    console.log('Testando conexão com Google Apps Script...');
    
    if (!checkGoogleScriptConfig()) {
      return {
        success: false,
        message: 'Google Apps Script não configurado. Configure REACT_APP_GOOGLE_SCRIPT_URL no arquivo .env.'
      };
    }

    // Testa enviando dados de teste
    const testData = {
      nome: 'Teste',
      telefone: '(11) 99999-9999',
      email: 'teste@email.com',
      cidade: 'São Paulo',
      estado: 'SP',
      bairro: 'Centro',
      profissoes: ['pedreiro'],
      habilidades: 'Teste de conexão',
      experiencia: 'Teste'
    };
    
    const response = await fetch(GOOGLE_SCRIPT_CONFIG.scriptUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(testData)
    });
    
    if (!response.ok) {
      return {
        success: false,
        message: 'Erro na conexão com Google Apps Script',
        error: `HTTP ${response.status}: ${response.statusText}`
      };
    }

    const result = await response.json();
    
    return {
      success: true,
      message: 'Conexão com Google Apps Script funcionando!',
      data: result
    };
    
  } catch (error) {
    return {
      success: false,
      message: 'Erro na conexão com Google Apps Script',
      error: error.message
    };
  }
};

/**
 * Função para criar cabeçalhos (não é mais necessária com Apps Script)
 */
export const setupSheetHeaders = async () => {
  return {
    success: true,
    message: 'Cabeçalhos devem ser criados manualmente na planilha. Veja a documentação.'
  };
};

